//#region src/locales/en/common.json
var e = {
	contact_slug: {
		city: "City",
		company_name: "Company name",
		country: "Country",
		email: "Email",
		first_name: "First name",
		last_name: "Last name",
		neighborhood: "Neighborhood",
		phone_number: "Phone number",
		postal_code: "Postal code",
		state_province: "State/Province",
		street_address: "Street address",
		street_number: "Street number",
		tax_number: "Tax number"
	},
	core: { error: {
		conflict_error_message: "Sorry, but someone else has already changed this entity. Please reload the page and try again!",
		internal_error_message: "Something went wrong. Please try again",
		maintenance_error: "We're currently undergoing scheduled maintenance. This action is temporarily unavailable. Please try again in a few minutes. Thank you for your patience",
		payload_to_large_error_message: "The file size is too big"
	} },
	global: {
		error: "Error",
		errors: { fields_toast_message: "Some fields contain invalid data, scroll down to resolve the issue" }
	},
	input: { url: {
		mail: "Mail",
		site: "Site",
		tel: "Tel"
	} },
	locale: {
		albania: "Albanian",
		arabic: "Arabic",
		chinese: "Chinese",
		czech: "Czech",
		danish: "Danish",
		dutch: "Dutch",
		english: "English",
		french: "French",
		german: "German",
		greek: "Greek",
		hindi: "Hindi",
		hungarian: "Hungarian",
		indonesian: "Indonesian",
		italian: "Italiano",
		japanese: "Japanese",
		norwegian: "Norwegian",
		polish: "Polish",
		portuguese: "Portuguese",
		romanian: "Romanian",
		russian: "Russian",
		serbian: "Serbian",
		slovak: "Slovak",
		slovenian: "Slovenian",
		spanish: "Spanish",
		swedish: "Swedish",
		thai: "Thai",
		turkish: "Turkish",
		ukrainian: "Ukrainian"
	},
	payment: {
		cash_on_delivery: "Cash on delivery",
		dlocal_boleto: "Boleto (Dlocal)",
		dlocal_card: "Credit cards (Dlocal)",
		dlocal_pix: "Pix (Dlocal)",
		flutterwave: "Flutterwave",
		gocardless: "Gocardless",
		mercadopago_boleto: "Boleto (Mercado Pago)",
		mercadopago_card: "Credit cards (Mercado Pago)",
		mercadopago_pix: "PIX (Mercado Pago)",
		mollie: "Mollie",
		paypal_connect: "Connect PayPal",
		paypal_edit_organization_name: "Edit organization name",
		paypal_rest: "PayPal",
		paypal_soap: "PayPal",
		paystack_card: "Credit cards (Paystack)",
		price_plan: "Plan",
		razorpay: "Razorpay",
		secure_and_pay: "Secure and Pay",
		square: "Square",
		stripe_applepay: "Apple Pay",
		stripe_bancotact: "Bancontact (Stripe)",
		stripe_card: "Credit or debit card",
		stripe_ideal: "iDeal (Stripe)",
		stripe_klarna: "Klarna (Stripe)",
		stripe_mbway: "MB WAY (Stripe)",
		stripe_multibanco: "Multibanco (Stripe)",
		xendit: { "3ds": "3D-Secure" },
		xendit_card: "Credit cards (Xendit)"
	}
}, t = { frontend_utils: e };
//#endregion
export { t as default, e as frontend_utils };
